export const SESSION_CHANNEL_NAME = "vogue-session";

type LogoutListener = () => void;

export class SessionChannel {
  private readonly channel: BroadcastChannel | null;
  private readonly logoutListeners = new Set<LogoutListener>();

  constructor(channelName = SESSION_CHANNEL_NAME) {
    this.channel = typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel(channelName);
    if (this.channel) {
      this.channel.onmessage = (event: MessageEvent<unknown>) => {
        if (event.data && typeof event.data === "object" && "type" in event.data && event.data.type === "logout") {
          for (const listener of this.logoutListeners) {
            listener();
          }
        }
      };
    }
  }

  get isAvailable(): boolean {
    return this.channel !== null;
  }

  publishLogout(): void {
    try {
      this.channel?.postMessage({ type: "logout" });
    } catch {
      // BroadcastChannel is best-effort. Server logout remains authoritative.
    }
  }

  subscribeToLogout(listener: LogoutListener): () => void {
    this.logoutListeners.add(listener);
    return () => this.logoutListeners.delete(listener);
  }

  destroy(): void {
    this.logoutListeners.clear();
    this.channel?.close();
  }
}

export const sessionChannel = new SessionChannel();
